<!--<div class="no_data_found_container">-->
<!--  <img src="assets/images/no-data-found-new.svg" alt="No Data" />-->
<!--  <p>-->
<!--    {{ msg }}-->
<!--  </p>-->
<!--</div>-->

<div class="no_data_found_container">
  <nz-empty
    [nzNotFoundImage]="'simple'||'assets/images/no-data-found-new.svg'"
    [nzNotFoundContent]="'No Data Found'"
  ></nz-empty>
</div>
